export default {
    common: {
        appName: 'Swift Invoice',
        back: 'Atrás',
        cancel: 'Cancelar',
        email: 'Correo electrónico',
        password: 'Contraseña',
        or: 'o',
        change: 'Cambiar',
        delete: 'Eliminar',
        save: 'Guardar',
        edit: 'Editar',
        add: 'Añadir',
        close: 'Cerrar',
        date: 'Fecha',
        total: 'Total',
        status: 'Estado',
        amount: 'Importe',
        quantity: 'Cantidad',
        rate: 'Tarifa',
        tax: 'Impuesto',
        discount: 'Descuento',
        note: 'Nota',
        notes: 'Notas',
        noData: 'Sin datos',
        description: 'Descripción',
        client: 'Cliente',
        item: 'Artículo',
        items: 'Artículos',
        type: 'Tipo',
        category: 'Categoría',
        phone: 'Teléfono',
        name: 'Nombre',
        subject: 'Asunto',
        saveAndClose: 'Guardar y cerrar',
        saveAndSendEmail: 'Guardar y enviar correo',
        sendEmail: 'Enviar correo',
        send: 'Enviar',
        print: 'Imprimir',
        moreActions: 'Más acciones',
        preparingPdf: 'Preparando PDF...',
        pdfPreparationFailed: 'No se pudo preparar el PDF',
        warning: 'Advertencia',
        ok: 'Aceptar',
        uploadSuccess: 'carga exitosa',
        saveSuccess: 'guardado con éxito',
        deleteSuccess: 'eliminado con éxito',
        deleteFailed: 'error al eliminar',
        saveFailed: 'error al guardar',
        loadFailed: 'error al cargar',
        systemError: 'error del sistema',
        sendSuccess: 'enviado con éxito',
        updateSuccess: 'actualizado con éxito',
        unsavedChangesMsg: 'Tienes cambios sin guardar. ¿Deseas guardarlos o descartarlos?',
        saveChangesTitle: '¿Guardar cambios?',
        confirmSave: 'Guardar',
        discard: 'Descartar',
        validEmail: 'Por favor, introduce una dirección de correo válida',
        deleteFailedMsg: 'error al eliminar',
        shipping: 'Envío',
        attachment: 'Adjunto',
        days: 'Días',
        excl: '(excl.)',
        incl: '(incl.)',
        of: 'de',
        batchActions: 'Acciones en lote',
        selected: 'seleccionados',
        select: 'Seleccionar',
        batchDeleteConfirm: '¿Eliminar {count} registros seleccionados?',
        batchActionSuccess: '{count} registros actualizados',
        batchActionPartial: '{processed} actualizados; {skipped} sin cambios',
        batchEmailInvalidRecipients: 'Añada un destinatario válido a cada documento',
        batchEmailSent: '{count} correos enviados',
        batchEmailPartial: '{sent} enviados; {failed} fallidos',
        emailHtmlNotAllowed: 'El asunto y el mensaje del correo no pueden contener HTML.'
    },
    emailVerification: {
        title: 'Verifique su correo electrónico',
        description: 'Enviamos un código de verificación a su correo de inicio de sesión:',
        codePlaceholder: 'Introduzca el código de verificación',
        enterCode: 'Introduzca el código del correo para continuar.',
        sent: 'Código de verificación enviado.',
        resent: 'Se ha enviado un nuevo código de verificación.',
        validFor: 'El código es válido durante 10 minutos.',
        verify: 'Verificar',
        resend: 'Reenviar',
        success: 'Correo verificado. Su correo se enviará ahora.',
        failed: 'El código de verificación es incorrecto o ha caducado.',
        limitReached: 'Ha alcanzado el límite de envíos de hoy.',
        remaining: 'Quedan {count} envíos hoy',
        contactUs: 'Contáctenos'
    },
    login: {
        heroPrefix: 'Facturación ',
        heroInvoicing: 'inteligente',
        heroMiddle: ',',
        heroSimplified: 'simplificada',
        heroSuffix: ' para ti.',
        subtitle1: 'Crea, envía y gestiona facturas sin esfuerzo.',
        subtitle2: 'Cobra más rápido con Swift Invoice.',
        feature1Title: 'Facturas profesionales',
        feature1Text: 'Crea facturas hermosas en minutos',
        feature2Title: 'Seguimiento en tiempo real',
        feature2Text: 'Realiza un seguimiento de pagos y estado de facturas',
        feature3Title: 'Seguro y confiable',
        feature3Text: 'Tus datos están seguros con seguridad de nivel empresarial',
        welcomeBack: 'Bienvenido de nuevo',
        signInToContinue: 'Inicia sesión en tu cuenta para continuar',
        enterEmail: 'Introduce tu correo electrónico',
        enterPassword: 'Introduce tu contraseña',
        rememberMe: 'Recuérdame',
        forgotPassword: '¿Olvidaste tu contraseña?',
        signIn: 'Iniciar sesión',
        signingIn: 'Iniciando sesión…',
        continueWithGoogle: 'Continuar con Google',
        continueWithApple: 'Continuar con Apple',
        createAccount: 'Crear cuenta',
        startUsing: 'Empieza a usar Swift Invoice',
        companyName: 'Nombre de la empresa',
        enterCompanyName: 'Introduce el nombre de tu empresa',
        alreadyHaveAccount: '¿Ya tienes una cuenta? Inicia sesión',
        footerRights: '© 2026 Swift Invoice. Todos los derechos reservados.',
        termsOfService: 'Términos de servicio',
        contactUs: 'Contáctanos: goodinvoicego@gmail.com',
        betaDialogBody: 'Nuestro equipo completó la primera versión de la web <br> Esta versión solo estará disponible para usuarios de iPhone <br> Mejoraremos la función web lo antes posible y la abriremos a todos <br>',
        ieDialogBody: 'Lo sentimos, debido a que el navegador IE tiene problemas de compatibilidad, actualmente no soportamos el navegador IE. Si necesitas usarlo, por favor descarga',
        resetPasswordTitle: 'Restablecer contraseña',
        sendResetEmail: 'Enviar correo de restablecimiento',
        resetEmailSent: 'Correo de restablecimiento enviado. Por favor, revisa tu bandeja de entrada.',
        bindingTitle: 'Vincular cuenta existente',
        bindingHintPrefix: 'Una cuenta ya usa el correo ',
        bindingHintSuffix: '. Introduce la contraseña de esa cuenta para vincular tu inicio de sesión de Google.',
        enterAccountPassword: 'Introduce la contraseña de la cuenta',
        linkAccount: 'Vincular cuenta',
        validEmail: 'Por favor, introduce una dirección de correo válida',
        validPassword: 'La contraseña debe tener 6 caracteres o más',
        validCompanyName: 'Por favor, completa el nombre de tu empresa',
        companyNameTooLong: 'El nombre de la empresa puede contener hasta {max} caracteres',
        turnstileUnavailable: 'No se pudo cargar la comprobación de seguridad. Inténtalo de nuevo.',
        turnstileExpired: 'La comprobación de seguridad ha caducado. Complétala de nuevo.',
        accountDataLoadFailed: 'La cuenta se verificó, pero no se pudieron cargar los datos de la empresa. Inténtalo de nuevo.'
    },
    account: {
        title: 'Cuenta',
        profile: 'Perfil',
        swiftAccount: 'Cuenta de Swift Invoice',
        connectSocial: 'Conectar cuentas sociales',
        companyLogo: 'Logo de la empresa',
        logoSize: 'Tamaño del logotipo',
        hideBusinessName: 'Ocultar nombre de la empresa',
        businessNameSize: 'Tamaño del nombre de la empresa',
        sizeSmall: 'Pequeño',
        sizeNormal: 'Normal',
        sizeBig: 'Grande',
        addLogo: 'Añadir logo',
        uploading: 'subiendo...',
        currentPlan: 'Plan actual: Swift {plan}',
        planActiveUntil: 'Plan activo hasta {date}',
        sharedWithMobile: 'Compartido con el móvil',
        subscriptionExpired: 'Tu suscripción ha expirado',
        planNote: 'Inicia sesión de nuevo si el estado de tu suscripción no se ha actualizado.',
        upgradeToPro: 'Mejorar a Swift Pro',
        viewPlans: 'Ver planes de suscripción',
        connecting: 'Conectando…',
        connectGoogle: 'Conectar Google',
        googleConnected: 'Google conectado',
        googleConnectedWithEmail: 'Google conectado ({email})',
        connectApple: 'Conectar Apple',
        appleConnected: 'Apple conectado',
        appleConnectedWithEmail: 'Apple conectado ({email})',
        logoUuidMissing: 'Falta el UUID del logo de la empresa',
        googleConnectedToast: 'Cuenta de Google conectada.',
        appleConnectedToast: 'Cuenta de Apple conectada.',
        logoUploadEmpty: 'Seleccione una imagen.',
        logoUploadSize: 'La imagen no puede superar los 10 MB.',
        logoUploadType: 'Solo se admiten imágenes JPEG, PNG y BMP.',
        logoUploadFailed: 'No se pudo subir el logotipo de la empresa.',
        logoUnavailable: 'El archivo del logotipo no está disponible. Vuelva a subirlo.',
        deleteAccount: 'Eliminar cuenta',
        deleteAccountDescription: 'Cierra permanentemente tu cuenta de Swift Invoice.',
        deleteAccountTitle: '¿Eliminar la cuenta?',
        deleteAccountWarning: 'Esta acción no se puede deshacer.',
        deleteAccountConfirm: 'Introduce tu contraseña para confirmar la eliminación de la cuenta.',
        deleteAccountPasswordPlaceholder: 'Introduce tu contraseña'
    },
    menu: {
        openNavigation: 'Abrir navegación',
        closeNavigation: 'Cerrar navegación',
        invoices: 'Facturas',
        estimates: 'Presupuestos',
        purchaseOrders: 'Órdenes de compra',
        creditMemos: 'Notas de crédito',
        time: 'Tiempo',
        items: 'Artículos',
        clients: 'Clientes',
        expenses: 'Gastos',
        reports: 'Informes',
        settings: 'Configuración',
        companyInfo: 'Información de la empresa',
        taxes: 'Impuestos',
        default: 'Predeterminado',
        customizeInvoice: 'Personalizar factura',
        sendFeedback: 'Enviar comentarios',
        newReply: '1 nueva respuesta',
        signOut: 'Cerrar sesión',
        signOutConfirm: '¿Seguro que quieres cerrar sesión?',
        addBusiness: 'Añadir empresa',
        newBusinessTitle: 'Nueva empresa',
        businessName: 'Nombre de la empresa',
        businessNamePlaceholder: 'Introduce el nombre de la empresa',
        createBusiness: 'Crear',
        businessNameRequired: 'Introduce el nombre de la empresa',
        createBusinessSuccess: 'Empresa creada correctamente',
        deleteBusiness: 'Eliminar empresa',
        deleteBusinessTitle: 'Eliminar empresa',
        deleteBusinessConfirm: '¿Eliminar «{name}»?',
        deleteBusinessWarning: 'Se eliminarán todos los datos de esta empresa.',
        deleteBusinessSuccess: 'Empresa eliminada correctamente',
        trialDaysLeft: 'Quedan {days} días de prueba',
        upgradeAccount: 'Mejorar cuenta'
    },
    network: {
        loginExpired: 'Sesión expirada, por favor inicia sesión de nuevo',
        requestTimeout: 'Tiempo de solicitud agotado, por favor revisa la red'
    },
    language: {
        label: 'Idioma',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        listLoadFailed: 'No se pudieron cargar las facturas.',
        summaryLoadFailed: 'No se pudieron cargar los totales de las facturas.',
        invoiceNumberPlaceholder: 'Introducir n.º de factura',
        filterAllClients: 'Todos los clientes',
        clientOptionsLoadFailed: 'No se pudieron cargar los clientes para filtrar.',
        filterAllStatuses: 'Todos los estados',
        filterUnpaid: 'No pagada',
        filterPaid: 'Pagada',
        filterOverdue: 'Vencida',
        filterUnsent: 'No enviada',
        filterSent: 'Enviada',
        filterStartDate: 'Fecha de inicio',
        filterEndDate: 'Fecha de fin',
        searchPlaceholder: 'Busca tus facturas',
        addInvoice: 'Añadir factura',
        overdueInvoices: 'Facturas vencidas',
        paidInvoices: 'Facturas pagadas',
        unpaidInvoices: 'Facturas impagadas',
        unsentInvoices: 'Facturas no enviadas',
        columnNumber: 'Número',
        columnClient: 'Cliente',
        columnStatus: 'Estado',
        statusFullyPaid: 'Pagada completamente',
        statusPartial: 'Parcial',
        statusOverdue: 'Vencida',
        statusUnsent: 'No enviada',
        statusSent: 'Enviada',
        statusOpened: 'Abierta',
        actionRecordPayment: 'Registrar pago',
        actionMarkAsSent: 'Marcar como enviada',
        actionCopy: 'Copiar',
        actionDelete: 'Eliminar',
        copyDialogTitle: 'Copiar factura',
        copyTargetType: 'Copiar a',
        copyOptions: 'Opciones de copia',
        copyClient: 'Copiar cliente',
        copyItems: 'Copiar artículos',
        copyAttachments: 'Copiar adjuntos',
        confirmDelete: 'Esto eliminará la factura. ¿Continuar?',
        copySuccess: 'Factura copiada',
        copyFailed: 'Error al copiar',
        deleteSuccess: 'Factura eliminada',
        deleteFailed: 'Error al eliminar',
        recordPaymentDialogTitle: 'Registrar pago',
        markAsFullyPaid: 'Marcar como pagada completamente',
        formAmount: 'Importe',
        formDate: 'Fecha',
        formPaymentMethod: 'Método de pago',
        formNote: 'Nota',
        allYears: 'Todos los años',
        errorNoOutstandingBalance: 'No hay saldo pendiente disponible para pagar',
        errorInvalidPaymentAmount: 'Introduzca un importe mayor que cero con un máximo de 5 decimales',
        dueDateToday: 'Hoy',
        dueDateDaysAgo: '{days} días atrás',
        dueDateInDays: 'en {days} días'
    },
    estimate: {
        filterAllStatuses: 'Todos los estados',
        pageTitlePurchaseOrders: 'Órdenes de compra',
        pageTitleEstimates: 'Presupuestos',
        pageTitleCreditMemos: 'Notas de crédito',
        searchPlaceholderPurchaseOrders: 'Busca tus órdenes de compra',
        searchPlaceholderEstimates: 'Busca tus presupuestos',
        searchPlaceholderCreditMemos: 'Busca tus notas de crédito',
        addPurchaseOrder: 'Añadir orden de compra',
        addEstimate: 'Añadir presupuesto',
        addCreditMemo: 'Añadir nota de crédito',
        columnNumber: 'Número',
        columnClient: 'Cliente',
        columnDate: 'Fecha',
        columnEmail: 'Correo electrónico',
        columnStatus: 'Estado',
        columnTotal: 'Total',
        statusUnsent: 'No enviado',
        statusSent: 'Enviado',
        actionMarkAsSent: 'Marcar como enviado',
        actionCopy: 'Copiar',
        actionDelete: 'Eliminar',
        actionConvertToInvoice: 'Convertir en factura',
        copyDialogTitle: 'Copiar {document}',
        copyTargetType: 'Copiar a',
        copyOptions: 'Opciones de copia',
        copyClient: 'Copiar cliente',
        copyItems: 'Copiar artículos',
        copyAttachments: 'Copiar adjuntos',
        confirmDelete: 'Esto eliminará {document}. ¿Continuar?',
        convertConfirm: '¿Convertir este {document} en una factura? La fecha se establecerá a hoy.',
        copySuccess: '{document} copiado',
        copyFailed: 'Error al copiar',
        convertSuccess: '{document} convertido en factura',
        convertFailed: 'Error al convertir',
        deleteSuccess: '{document} eliminado',
        deleteFailed: 'Error al eliminar',
        dueDateToday: 'Hoy',
        dueDateDaysAgo: '{days} días atrás',
        dueDateInDays: 'en {days} días'
    },
    item: {
        pageTitle: 'Artículos',
        searchPlaceholder: 'Busca tus artículos',
        addItem: 'Añadir artículo',
        columnInventoryCountUnit: 'Recuento de inventario/Unidad',
        noDescription: 'Sin descripción del artículo'
    },
    client: {
        pageTitle: 'Clientes',
        searchPlaceholder: 'Busca tus clientes',
        addClient: 'Añadir cliente',
        columnClientName: 'Nombre del cliente',
        columnEmail: 'Correo electrónico',
        columnPhone: 'Teléfono',
        columnBalanceDue: 'Saldo pendiente',
        noNameFallback: 'SIN NOMBRE'
    },
    expense: {
        pageTitle: 'Gastos',
        searchPlaceholder: 'Busca tus gastos',
        allCategories: 'Todas las categorías',
        noCategory: 'Sin categoría',
        categoryLoadFailed: 'No se pudieron cargar las categorías de gastos.',
        addExpense: 'Añadir gasto',
        columnDescription: 'Descripción',
        columnDate: 'Fecha',
        columnTotal: 'Total',
        tip: 'Propina'
    },
    report: {
        headerTitle: 'Informes',
        tabDashboard: 'Panel',
        tabReportList: 'Lista de informes',
        export: 'Exportar',
        annualSalesByClient: 'Ventas anuales por cliente',
        otherClients: 'Otros clientes',
        totalOutstandingBalance: 'Saldo pendiente total',
        invoicesCountSuffix: 'facturas',
        byMonth: 'Por mes',
        byQuarter: 'Por trimestre',
        noSalesFound: 'No se encontraron ventas',
        filterReportTypes: 'Tipos de informe',
        filterTimePeriod: 'Período de tiempo',
        filterView: 'Ver',
        filterTaxYear: 'Año fiscal',
        filterQuarter: 'Trimestre',
        filterMonth: 'Mes',
        filterStartDate: 'Fecha de inicio',
        filterEndDate: 'Fecha de fin',
        invalidCustomDateRange: 'La fecha de inicio no puede ser posterior a la fecha de finalización',
        searchClientName: 'Buscar nombre del cliente',
        searchItemName: 'Buscar nombre del artículo',
        searchSalesJournal: 'Buscar número de factura o nombre del cliente',
        searchPaymentsJournal: 'Buscar número de factura, nombre del cliente o tipo de pago',
        periodMonth: 'Mes',
        periodQuarter: 'Trimestre',
        periodYear: 'Año',
        periodAllTaxYears: 'Todos los años fiscales',
        periodCustom: 'Personalizado',
        taxYearLabel: 'Año fiscal {year}',
        quarterLabel: 'T{quarter} Año fiscal {year}',
        optionMonthly: 'Mensual',
        optionQuarterly: 'Trimestral',
        customerAgingTitle: 'Antigüedad de clientes',
        noDataForDateRange: 'No hay datos para este rango de fechas',
        typeSalesByDate: 'Ventas por fecha',
        typeSalesByClient: 'Ventas por cliente',
        typeSalesByItem: 'Ventas por artículo',
        typeSalesJournal: 'Diario de ventas',
        typePaymentsByDate: 'Pagos por fecha',
        typePaymentsByClient: 'Pagos por cliente',
        typePaymentsByType: 'Pagos por tipo',
        typePaymentsJournal: 'Diario de pagos',
        typeExpenseByCategory: 'Gastos por categoría',
        typeExpenseJournal: 'Diario de gastos',
        typeProfitLoss: 'Pérdidas y ganancias',
        typeTaxes: 'Impuestos',
        typeCustomerAging: 'Antigüedad de clientes',
        allYears: 'Todos los años',
        allTime: 'Todo el tiempo',
        allSales: 'Todas las ventas',
        taxYearSales: 'Ventas del año fiscal {year}',
        firstColumnMonth: 'Mes',
        firstColumnQuarter: 'Trimestre',
        firstColumnYear: 'Año',
        firstColumnDay: 'Día',
        firstColumnDate: 'Fecha',
        columnSubTotal: 'Subtotal',
        columnTax: 'Impuesto',
        columnDiscount: 'Descuento',
        columnTotal: 'Total',
        columnAmountPaid: 'Importe pagado',
        columnAmountOwed: 'Importe adeudado',
        columnClient: 'Cliente',
        columnItem: 'Artículo',
        columnUnitType: 'Tipo de unidad',
        columnQuantity: 'Cantidad',
        columnRateAvg: 'Tarifa (prom.)',
        columnInvoiceDate: 'Fecha de factura',
        columnInvoiceNo: 'N° de factura',
        columnType: 'Tipo',
        columnPaymentDate: 'Fecha de pago',
        columnCategory: 'Categoría',
        columnExpenseDate: 'Fecha de gasto',
        columnMerchant: 'Comerciante',
        columnDescription: 'Descripción',
        columnCurrentDue: 'Pendiente actual',
        column1To30DaysOverdue: '1-30 días vencido',
        column31To60DaysOverdue: '31-60 días vencido',
        column61To90DaysOverdue: '61-90 días vencido',
        column91PlusDaysOverdue: '91+ días vencido',
        columnSection: 'Sección',
        columnAmount: 'Importe',
        columnPreTaxSales: 'Ventas antes de impuestos',
        columnTaxLabel: 'Nombre del impuesto',
        columnTaxRate: 'Tasa de impuesto',
        columnTotalTax: 'Impuesto total',
        columnPostTaxTotal: 'Total después de impuestos',
        profitLossTitle: 'Pérdidas y ganancias',
        taxesTitle: 'Impuestos',
        profitLossRevenue: 'Ingresos',
        profitLossExpense: 'Gastos',
        profitLossProfit: 'Beneficio',
        profitLossCash: 'Efectivo',
        profitLossAccrued: 'Devengado',
        profitLossAccountsReceivables: 'Cuentas por cobrar',
        profitLossNone: '[Ninguno]',
        profitLossTotalExpenses: 'Gastos totales',
        profitLossCashProfit: 'Beneficio en efectivo',
        profitLossAccruedProfit: 'Beneficio devengado',
        monthNames: 'Ene, Feb, Mar, Abr, May, Jun, Jul, Ago, Sep, Oct, Nov, Dic',
        totalRowLabel: 'Total'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Añadir',
        initialDataLoadFailed: 'No se pudo cargar la configuración del documento. La edición y el guardado están deshabilitados.',
        searchSuggestionsLoadFailed: 'No se pudieron cargar las sugerencias de búsqueda.',
        invoicePrefix: 'prefijo de factura',
        tabCreate: 'Crear',
        tabPreview: 'Vista previa',
        tabSendEmail: 'Enviar correo',
        sectionClient: 'Cliente',
        addClient: 'Añadir cliente',
        dialogClientInfo: 'Información del cliente',
        basicInformation: 'Información básica',
        labelName: 'Nombre',
        labelEmail: 'Correo electrónico',
        labelPhone: 'Teléfono',
        billingAddress: 'Dirección de facturación',
        labelLine1: 'Línea 1',
        labelLine2: 'Línea 2',
        labelLine3: 'Línea 3',
        shippingAddress: 'Dirección de envío',
        labelShippingName: 'Nombre de envío',
        labelNotes: 'Notas',
        placeholderCreateOrSelect: 'Crea o selecciona uno...',
        placeholderClientNotes: 'Añade notas sobre el cliente. No pueden verlas',
        sectionItems: 'Artículos',
        saveToYourItem: 'Guardar en tu artículo',
        stock: 'Existencias:',
        placeholderItemCode: 'código de artículo',
        placeholderQuantity: 'Cantidad',
        placeholderRate: 'tarifa',
        placeholderInputDescription: 'Introduce descripción',
        placeholderInputComment: 'Introduce comentario',
        placeholderAddRecipient: 'Añadir destinatario',
        cc: 'Cc',
        bcc: 'Cco',
        placeholderEmailSubject: 'Asunto del correo',
        placeholderMessage: 'Escribe tu mensaje...',
        labelTo: 'Para',
        labelSubject: 'Asunto',
        sectionAttachments: 'Adjuntos',
        sectionComment: 'Comentario',
        addItem: 'Añadir artículo',
        addPhoto: 'Añadir foto',
        addPayment: 'Añadir pago',
        goBack: 'volver',
        dialogShippingInfo: 'Información de envío',
        dialogRecordPayment: 'Registrar pago',
        dialogJobDetails: 'Detalles del trabajo',
        labelAmount: 'Importe',
        labelShipDate: 'Fecha de envío',
        labelShipVia: 'Enviar vía',
        labelTrackingNumber: 'Número de seguimiento',
        labelFob: 'FOB',
        columnDate: 'Fecha',
        columnType: 'Tipo',
        msgClientEmailError: 'error de correo del cliente',
        msgAmountGreaterThanZero: 'El importe debe ser mayor que cero',
        msgInvalidAmount: 'El importe debe estar entre 0 y 999.999.999.999.999 y tener como máximo 5 decimales',
        calculatedAmountOutOfRange: 'El importe calculado supera el rango admitido',
        msgTextTooLong: '{field} no puede superar los {max} caracteres',
        msgTextTooLongBytes: '{field} no puede superar los {max} bytes UTF-8',
        msgInvalidJobDetails: 'Los detalles del trabajo contienen datos no válidos',
        msgMorePaymentThanBalance: 'Más pago que el saldo pendiente',
        mailSentSuccessfully: 'Correo enviado con éxito',
        cumulativeTaxNotice: 'La web no soporta la acumulación de impuestos en la factura...',
        confirmUnsavedChanges: 'Tienes cambios sin guardar. ¿Deseas guardarlos o descartarlos?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Impuesto, descuento y retención',
        purchaseOrder: 'Orden de compra',
        placeholderPurchaseOrderPrefix: 'prefijo de orden de compra',
        placeholderCreditMemoPrefix: 'prefijo de nota de crédito',
        placeholderEstimatePrefix: 'prefijo de presupuesto',
        labelStatus: 'Estado',
        statusIssued: 'Emitida',
        statusApproved: 'Aprobada',
        statusPending: 'Pendiente',
        statusWithdrawn: 'Retirada',
        tax: 'Impuesto'
    },
    createEstimate: {
        pageTitlePrefix: 'Añadir',
        cumulativeTaxNotice: 'La web no soporta la acumulación de impuestos en el presupuesto...'
    },
    updateInvoice: {
        pageTitlePrefix: 'Actualizar',
        deletePrefix: 'Eliminar',
        confirmDelete: 'Esto eliminará la factura. ¿Continuar?',
        cumulativeTaxNotice: 'Esta factura contiene impuestos acumulativos. La web no soporta esta función temporalmente'
    },
    updateEstimate: {
        pageTitlePrefix: 'Actualizar',
        deletePrefix: 'Eliminar',
        confirmDelete: 'Esto eliminará {document}. ¿Continuar?',
        cumulativeTaxNotice: 'Este presupuesto contiene impuestos acumulativos. La web no soporta esta función temporalmente'
    },
    createAccount: {
        title: 'Crear una cuenta',
        placeholderEmail: 'correo',
        placeholderPassword: 'Contraseña',
        placeholderCompanyName: 'Nombre de la empresa',
        createAccountButton: 'Crear cuenta',
        alreadyHaveAccount: '¿Ya tienes una cuenta?',
        signIn: 'Iniciar sesión',
        validEmail: 'Por favor, introduce una dirección de correo válida',
        validPassword: 'La contraseña debe tener 6 caracteres o más',
        validCompanyName: 'Por favor, completa el nombre de tu empresa',
        companyNameTooLong: 'El nombre de la empresa puede contener hasta {max} caracteres'
    },
    clientCreate: {
        pageTitle: 'Añadir cliente',
        basicInformation: 'Información básica',
        labelName: 'Nombre',
        placeholderName: 'Introduce un nombre...',
        labelEmail: 'Correo electrónico',
        placeholderEmail: 'Introduce una dirección de correo...',
        labelPhone: 'Teléfono',
        placeholderPhone: 'Introduce un número de teléfono...',
        billingAddress: 'Dirección de facturación',
        labelLine1: 'Línea 1',
        labelLine2: 'Línea 2',
        labelLine3: 'Línea 3',
        shippingAddress: 'Dirección de envío',
        sameAsBilling: 'Igual que la dirección de facturación',
        labelShippingName: 'Nombre de envío',
        labelShippingLine1: 'Línea 1',
        labelShippingLine2: 'Línea 2',
        labelShippingLine3: 'Línea 3',
        labelNotes: 'Notas',
        placeholderNotes: 'Añade notas sobre el cliente. No pueden verlas',
        defaultDiscount: 'Descuento predeterminado',
        validDefaultDiscount: 'Introduce un descuento predeterminado válido',
        validName: 'Introduce el nombre del cliente',
        validEmail: 'Por favor, introduce una dirección de correo válida'
    },
    clientUpdate: {
        pageTitle: 'Actualizar cliente',
        confirmDelete: 'Esto eliminará el cliente. ¿Continuar?'
    },
    itemCreate: {
        pageTitle: 'Añadir artículo',
        itemTitle: 'Artículo',
        labelCost: 'Coste',
        rateSign: 'Signo del precio',
        inventorySign: 'Signo del ajuste de inventario',
        labelUnit: 'Unidad',
        placeholderUnit: 'Unidad',
        defaultTaxes: 'Impuestos predeterminados',
        taxOff: 'desactivado',
        inventoryTitle: 'Inventario',
        currentInventory: 'Inventario actual',
        adjustInventory: 'Ajustar inventario',
        increase: 'Aumentar',
        decrease: 'Disminuir',
        placeholderQuantity: 'Cantidad',
        placeholderDateAndTime: 'Fecha y hora',
        placeholderNote: 'Nota',
        addButton: 'Añadir',
        columnDate: 'Fecha',
        columnQuantity: 'Cantidad',
        columnNote: 'Nota',
        withholdingTitle: 'Retención',
        msgInventoryCannotDisable: 'El inventario no se puede desactivar una vez activado',
        msgDescriptionRequired: 'La descripción del artículo es obligatoria',
        msgInvalidRate: 'El precio debe estar entre -999.999.999.999.999 y 999.999.999.999.999 y tener como máximo 4 decimales',
        msgInvalidCost: 'El coste debe estar entre 0 y 999.999.999.999.999 y tener como máximo 5 decimales',
        msgInvalidInventory: 'La cantidad debe estar entre 0 y 999.999.999.999.999 y tener como máximo 5 decimales',
        msgInvalidUnit: 'La unidad no puede contener && ni superar los 255 caracteres',
        msgQuantityRequired: 'La cantidad es obligatoria',
        msgDateRequired: 'La fecha y hora son obligatorias'
    },
    itemUpdate: {
        pageTitle: 'Editar artículo',
        columnInvoice: 'Factura',
        confirmDelete: 'Esto eliminará el artículo. ¿Continuar?'
    },
    createStatement: {
        pageTitle: 'Estado de cuenta',
        tabPreview: 'Vista previa',
        tabSendEmail: 'Enviar correo',
        createAction: 'Crear estado de cuenta',
        from: 'Desde',
        to: 'Hasta',
        invoices: 'Facturas',
        balanceDue: 'Saldo pendiente',
        editTitle: 'Editar estado de cuenta',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha de fin',
        onlyShowUnpaid: 'Mostrar solo facturas impagadas',
        unpaidOnlyActive: 'Este estado de cuenta solo incluye facturas impagadas.',
        dateRequired: 'Las fechas de inicio y fin son obligatorias',
        invalidDateRange: 'La fecha de fin no puede ser anterior a la fecha de inicio'
    },
    time: {
        pageTitle: 'Tiempo',
        unbilled: 'No facturado',
        billed: 'Facturado',
        searchPlaceholder: 'Buscar tiempo por cliente o descripción',
        addTime: 'Añadir tiempo',
        noTime: 'No hay registros de tiempo',
        noTimeDescription: 'Crea un registro para controlar el trabajo facturable.',
        noClient: 'Sin cliente',
        filterAndSort: 'Filtrar y ordenar',
        year: 'Año',
        groupBy: 'Agrupar por',
        sortBy: 'Ordenar por',
        order: 'Orden',
        yearly: 'Anual',
        quarterly: 'Trimestral',
        monthly: 'Mensual',
        ascending: 'Ascendente',
        descending: 'Descendente',
        duration: 'Duración',
        createTitle: 'Crear tiempo',
        editTitle: 'Tiempo',
        selectClient: 'Seleccionar un cliente',
        start: 'Inicio',
        end: 'Fin',
        hours: 'horas',
        minutes: 'minutos',
        ratePreset: 'Tarifa',
        customRate: 'Tarifa personalizada',
        rateName: 'Nombre de la tarifa',
        showRateName: 'Mostrar el nombre de la tarifa en la factura',
        invalidDate: 'La hora de inicio y fin son obligatorias',
        endBeforeStart: 'La hora de fin no puede ser anterior a la de inicio',
        invalidDuration: 'La duración debe coincidir con las horas de inicio y fin',
        invalidRate: 'La tarifa debe estar entre 0 y 999999999999999 y tener como máximo 5 decimales',
        rateNameTooLong: 'El nombre de la tarifa no puede superar los 255 caracteres',
        descriptionTooLong: 'La descripción no puede superar los 3000 caracteres',
        confirmDelete: 'Se eliminará este registro de tiempo. ¿Continuar?'
    },
    setting: {
        taxInfo: 'Información de impuestos',
        taxes: 'Impuestos',
        taxYearStarts: 'El año fiscal comienza',
        taxYearStartSubtitle: 'Establece el primer día del año fiscal',
        rateLabel: 'Tasa(%)',
        abbreviation: 'Abreviatura',
        addTax: 'Añadir impuesto',
        month: 'Mes',
        day: 'Día',
        monthPlaceholder: 'Mes',
        dayPlaceholder: 'Día',
        saveTaxYearStart: 'Guardar',
        deleteDialogTitle: 'Eliminar',
        confirmDeleteTax: '¿Seguro que quieres eliminar este impuesto?',
        deleteConfirm: 'Eliminar',
        taxInfoDialogTitle: 'Información de impuestos',
        taxName: 'Nombre del impuesto',
        standardRate: 'Tasa estándar (%)',
        additionalRate: 'Tasa adicional',
        deleteRateX: 'X',
        addRate: 'Añadir tasa',
        taxType: 'Tipo de impuesto',
        exclusive: 'Exclusivo',
        inclusive: 'Inclusivo',
        close: 'cerrar',
        saveTax: 'Guardar impuesto',
        cantOpenDetailMessage: 'Este impuesto contiene impuestos acumulativos. La web no soporta esta función temporalmente',
        closeButton: 'Cerrar',
        rateIsRequired: 'la tasa es obligatoria',
        rateIsRequiredMsg: 'La tasa es obligatoria',
        monthAndDayRequired: 'El mes y el día son obligatorios',
        additionalRateNumber: 'Tasa adicional {number} (%)',
        taxNameRequired: 'El nombre del impuesto es obligatorio',
        invalidTaxRate: 'La tasa debe estar entre 0 y 999999999999999 y tener como máximo 4 decimales',
        duplicateTaxRate: 'Las tasas de impuestos deben ser únicas',
        taxRatesTooLong: 'Hay demasiadas tasas de impuestos para guardar',
        withholdingNameRequired: 'La abreviatura es obligatoria cuando la retención está activa',
        moreRate: ' tasa más',
        moreRates: ' tasas más'
    },
    companyInfo: {
        title: 'Información de la empresa',
        details: 'Detalles',
        businessName: 'Nombre comercial',
        businessNamePlaceholder: 'Nombre comercial',
        name: 'Nombre',
        phone: 'Teléfono',
        email: 'Correo electrónico',
        businessNumber: 'Número de empresa',
        taxNo: 'N° fiscal',
        deleteField: 'eliminar',
        addNewField: 'Añadir nuevo campo',
        address: 'Dirección',
        line1: 'Línea 1',
        line2: 'Línea 2',
        line3: 'Línea 3',
        currency: 'Moneda',
        currencyLabel: 'Moneda',
        symbol: 'Símbolo',
        placement: 'Posición',
        before: 'Antes',
        after: 'Después',
        thousandSymbol: 'Símbolo de millar',
        decimalSymbol: 'Símbolo decimal',
        decimalPlaces: 'Decimales',
        example: 'Ejemplo',
        terms: 'Términos',
        termsLabel: 'Términos',
        termSameDay: 'Mismo día',
        term7Days: '7 días',
        term14Days: '14 días',
        term21Days: '21 días',
        term30Days: '30 días',
        term45Days: '45 días',
        term60Days: '60 días',
        term90Days: '90 días',
        term180Days: '180 días',
        term365Days: '365 días',
        paymentInfo: 'Información de pago',
        displayOnInvoices: 'Mostrar en facturas',
        titlePlaceholder: 'Título',
        jobDetails: 'Detalles del trabajo',
        deleteJobDetail: 'eliminar',
        addNewJobField: 'añadir nuevo campo',
        fieldNameRequired: '{field}: el nombre del campo es obligatorio',
        reservedCharacters: '{field}: el nombre no puede contener : ni &&, y el valor no puede contener &&',
        serializedDataTooLong: 'Los datos de {field} superan el límite de la base de datos',
        textDataTooLong: '{field} supera el límite de la base de datos'
    },
    default: {
        title: 'Predeterminado',
        emailMessage: 'Mensaje de correo',
        enterDescription: 'Introduce una descripción',
        emailCc: 'Cc del correo',
        emailBcc: 'Cco del correo',
        emailTip: 'Envía un correo al mismo tiempo a la dirección anterior.',
        defaultComments: 'Comentarios predeterminados',
        invoice: 'Factura',
        estimate: 'Presupuesto',
        purchaseOrder: 'Orden de compra',
        creditMemo: 'Nota de crédito',
        emailValidError: 'correo válido'
    },
    invoiceDesign: {
        template: 'Plantilla',
        color: 'Color',
        labels: 'Etiquetas',
        labelInvoice: 'Factura',
        labelEstimate: 'Presupuesto',
        labelPurchaseOrder: 'Orden de compra',
        labelCreditMemo: 'Nota de crédito',
        labelReceipt: 'RECIBO',
        labelTermsFormat: 'Formato de términos',
        labelBillTo: 'Facturar a',
        labelFor: 'Para',
        labelDate: 'Fecha',
        labelInvoiceNo: 'N° de factura',
        labelEstimateNo: 'N° de presupuesto',
        labelPoNo: 'N° de OC',
        labelCreditMemoNo: 'N° de nota de crédito',
        labelDueDate: 'Fecha de vencimiento',
        labelTerms: 'Términos',
        labelAmount: 'Importe',
        labelCode: 'Código',
        labelDescription: 'Descripción',
        labelQuantity: 'Cantidad',
        labelRate: 'Tarifa',
        labelTax: 'Impuesto',
        labelSubtotal: 'Subtotal',
        labelBalanceDue: 'Saldo pendiente',
        labelDiscount: 'Descuento',
        labelNonTaxableItem: 'Artículo no imponible',
        labelPaid: 'Pagado',
        labelShipping: 'Envío',
        labelTotal: 'Total',
        labelIncludes: 'Incluye',
        labelTotalAmountPaid: 'Importe total pagado',
        labelShipDate: 'Fecha de envío',
        labelShipTo: 'Enviar a',
        labelShipVia: 'Enviar vía',
        labelTrackingNo: 'N° de seguimiento',
        labelFob: 'F.O.B',
        prefix: 'Prefijo',
        prefixInvoice: 'Factura',
        prefixEstimate: 'Presupuesto',
        prefixPurchaseOrder: 'Orden de compra',
        prefixCreditMemo: 'Nota de crédito',
        nextNumber: 'Siguiente número',
        numberingBeginsAt: 'La numeración comienza en',
        nextNumberInvoice: 'Factura',
        nextNumberEstimate: 'Presupuesto',
        nextNumberPurchaseOrder: 'Orden de compra',
        nextNumberCreditMemo: 'Nota de crédito',
        options: 'Opciones',
        optionTerms: 'Términos',
        optionDueDate: 'Fecha de vencimiento',
        optionShippingAddress: 'Dirección de envío',
        optionProductCode: 'Código de producto',
        optionQuantityAndRate: 'Cantidad y tarifa',
        optionUnit: 'Unidad',
        optionTax: 'Impuesto',
        optionAmount: 'Importe',
        optionNonTaxableItemStar: 'Estrella de artículo no imponible',
        optionDiscount: 'Mostrar descuento',
        optionTaxBreakdown: 'Desglose de impuestos',
        optionPaymentHistory: 'Historial de pagos',
        optionStamp: 'Sello',
        optionPageNumber: 'Número de página',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: '¡Gracias por su negocio! Esperamos que esté satisfecho con nuestro trabajo. Por favor, realice el pago dentro de 15 días.¿Preguntas? ¿Comentarios? Contáctenos al(111)111-1234 o escríbanos a example@owner.com, estaremos encantados de responder cualquier pregunta o inquietud.',
        previewSubtotal: 'Subtotal',
        previewVat: 'IVA 17.00%',
        previewPayment1: 'Pago el 1 oct, 2019',
        previewPayment2: 'Pago el 2 oct, 2019',
        invalidNextNumber: 'Cada número siguiente debe ser un entero entre 0 y {max}'
    },
    feedback: {
        title: 'Enviar comentarios',
        invalidEmailNoticePrefix: 'La dirección de correo en tu cuenta no es válida, por lo que no pudimos contactarte. Por favor, envía tus comentarios desde una dirección de correo válida a',
        invalidEmailNoticeSuffix: 'Si es posible, incluye una captura de pantalla del problema; nos ayudará a investigarlo y resolverlo.',
        replyTip: 'Después de enviar, por favor revisa tu correo para la respuesta.',
        contextTip: 'Los siguientes datos de cuenta y navegador se incluirán con tus comentarios:',
        content: 'Contenido',
        enterDescription: 'Introduce una descripción',
        contentTooLong: 'El contenido no puede superar los {max} caracteres'
    },
    createExpense: {
        title: 'Añadir gasto',
        description: 'Descripción',
        expenseDescriptionPlaceholder: 'Descripción del gasto',
        total: 'Total',
        tax: 'Impuesto',
        tip: 'Propina',
        expenseDate: 'Fecha de gasto',
        merchant: 'Comerciante',
        merchantPlaceholder: 'Introduce el nombre del comerciante',
        categoryPlaceholder: 'Selecciona categoría',
        addNewCategory: 'Añadir nueva categoría',
        deletePhoto: 'Eliminar',
        addPhoto: 'Añadir foto',
        deleteCategory: 'eliminar',
        addCategory: 'Añadir categoría',
        descriptionTooLong: 'La descripción no puede superar los 3.000 caracteres.',
        merchantTooLong: 'El nombre del comercio no puede superar los 255 caracteres.',
        amountInvalid: 'El total, el impuesto y la propina deben estar entre 0 y 999999999999999 y tener como máximo 5 decimales.',
        categoryRequired: 'El nombre de la categoría es obligatorio.',
        categoryTooLong: 'El nombre de la categoría no puede superar los 255 caracteres.',
        photoUploadFailed: 'No se pudo subir la foto. Inténtalo de nuevo.'
    },
    updateExpense: {
        title: 'Actualizar gasto',
        deleteExpense: 'Eliminar gasto',
        confirmDeleteMsg: 'Esto eliminará el gasto. ¿Continuar?'
    },
    notFound: {
        oops: '¡UPS!',
        notFoundMsg: 'No podemos encontrar la página que buscas.',
        takeMeHome: 'Llévame al inicio'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Envío gratis',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Ordenador',
        previewItem2: 'Teléfono',
        previewItem3: 'Pastel de cumpleaños',
        previewTaxRate: '17%',
        nonTaxableNote: '* Indica artículo no imponible',
        thanksMessage: '¡Gracias por su negocio! Esperamos que esté satisfecho con nuestro trabajo. Por favor, realice el pago dentro de 15 días.¿Preguntas? ¿Comentarios? Contáctenos al(111)111-1234 o escríbanos a example@owner.com, estaremos encantados de responder cualquier pregunta o inquietud.',
        subtotal: 'Subtotal',
        vat: 'IVA 17.00%',
        payment1: 'Pago el 1 oct, 2019',
        payment2: 'Pago el 2 oct, 2019',
        balanceDue: 'Saldo pendiente'
    }
};
